module.exports = __webpack_public_path__ + "static/img/pay3.7dcc4a7c.png";